<div class="doing-wrapper" [class.expanded]="showDetails" [ngClass]="doing.state">
    <div *ngIf="showDetails && !isSubdoing" class="follow-up-wrapper">
      <app-doing-form [(ngModel)]="followUpDoing" [defaultFollowUpDate]="defaultFollowUpDate" [customerSearchEnabled]="(doing.customer == null)" [userSearchEnabled]="false" [cooperationSearchEnabled]="false"
                      (doingSubmitted)="addFollowUp($event)" placeholderText="Follow-Up hinzufügen"></app-doing-form>
    </div>
  <div *ngIf="editMode">
      <app-doing-form [customerSearchEnabled]="true" placeholderText="Doing bearbeiten" (doingSubmitted)="updateDoing($event)" [(ngModel)]="doing"></app-doing-form>
  </div>
  <div class="doing-actions" *ngIf="editMode">
    <div class="action text-gray-800" (click)="editMode = false">Abbrechen</div>
  </div>

  <div *ngIf="!editMode" class="doing">
      <div class="doing-date">
          {{ doing.created | formatDate: 'DD.MM.YYYY HH:mm' }}
      </div>

      <div class="doing-tags pl-8 relative">
          <div [style.background-image]="'url(' + logo + ')'" class="h-6 w-6 bg-gray-200 rounded-full bg-contain inline-block mr-1 absolute left-0 ml-1 vertical-center bg-no-repeat bg-center"></div>
          <div class="tag" *ngIf="doing.markedUser">
              {{ doing.markedUser.username }}
          </div>
          <div [routerLink]="['/companies', doing.customer.id]" class="tag" *ngIf="doing.customer">{{ doing.customer.companyDisplayName || doing.customer.companyName }}</div>
          <div [routerLink]="['/cooperations', doing.cooperation.id]" class="tag" *ngIf="doing.cooperation">{{ doing.cooperation.name }}</div>

      </div>

      <div class="text" (click)="editDoing()">
          {{ doing.text }} <span *ngIf="doing.user?.abbreviation">//{{ doing.user?.abbreviation }}</span>
      </div>
      <div class="text-gray-700 text-2xs px-2" *ngIf="doing.changeLog?.length > 0">
          Zuletzt bearbeitet von {{ doing.changeLog[0].username }}
      </div>

      <div class="doing-actions">
          <div class="action text-red-600" (click)="deleteDoing()" *ngIf="doing.deleteable">Entfernen</div>
          <div class="action" (click)="picker2.open()" [class.overdue]="doing.followUp < now">
              <span class="iconify inline-block mr-1" data-icon="fluent-mdl2:reminder-time"></span>
              {{ doing.followUp | date: 'dd.MM.yyyy' }}
              <input (ngModelChange)="followUpDateChanged($event)" [(ngModel)]="doing.followUp" class="invisible-calendar-input" [matDatepicker]="picker2">
              <mat-datepicker #picker2></mat-datepicker>
          </div>
          <div class="action text-blue-800 overflow-hidden" *ngIf="doing.thread && !isSubdoing && doing?.latestReceivedMessage?.account && doing?.thread" [routerLink]="['/messages', doing.latestReceivedMessage.account.id, doing.latestReceivedMessage.id]" [title]="doing.thread.title">
              <span class="iconify inline-block mr-1" data-icon="tabler:message"></span>
              {{ doing.thread.title }}
          </div>
          <div class="action text-blue-600" [matMenuTriggerFor]="doingStatusMenu">
              Status <span class="iconify inline" data-icon="bx:bx-chevron-down"></span>
          </div>
      </div>

      <mat-menu #doingStatusMenu="matMenu">
        <button (click)="success()" mat-menu-item>Angenommen</button>
        <button (click)="fail()" mat-menu-item>Abgelehnt</button>
        <button (click)="reopen()" mat-menu-item>Offen</button>
      </mat-menu>

    </div>
    <div *ngIf="showDetails && !isSubdoing" (click)="showDetails = false;" title="Vorgänger ausblenden" class="hide-predecessors"></div>
    <div *ngIf="!showDetails && !isSubdoing" (click)="showDetails = true;" title="Vorgänger anzeigen" class="show-predecessors"></div>
    <div class="predecessor-container" *ngIf="predecessors && predecessors.length > 0 && !isSubdoing">
        <div [class.hidden]="!showDetails" class="predecessor" *ngFor="let predecessor of predecessors">
            <app-doing [isSubdoing]="true" (deleted)="deletedHandler($event)" [doing]="predecessor"></app-doing>
        </div>
    </div>



</div>

